export const watch = {
  hoaId() {
    this.getRefreshedUnitGroups()
  },
  selectedRow(row) {
    if (this.isDebug == true) console.debug('selected', { row })

    if (row && row != undefined) {
      this.formData.unitGroupID = row.unitGroupID
      this.formData.Name = row.name
    }

    if (this.isDebug == true)
      console.debug('update formData values=' + JSON.stringify(this.formData))
  },
  unitGroupList() {
    this.updateRows({
      list: this.unitGroupList
    })
  }
}
